// test2056
(2056 && 0);
